import { Flex as BaseFlex } from 'mds-web-ui'
import React from 'react'
import styled from 'styled-components'
import { border } from 'styled-system'

import { Paragraph, fontSizes } from '../utils/Typography'
import { BonoboLink } from '../utils/BonoboLink'

export const ShareWithUs = ({ ...props }) => {
  return (
    <Flex
      bg="#000"
      color="#fff"
      borderRadius={16}
      justifyContent="space-between"
      alignItems="center"
      flexDirection={['column', 'row']}
      p={[3, 4]}
      gap={[3, 4]}
      {...props}
    >
      <Paragraph
        m={0}
        fontSize={fontSizes.copy}
        color="inherit"
        textAlign={['center', 'left']}
        pt={[2, 0]}
        px={[2, 0]}
      >
        Made something amazing in Flow and want to share it with the world?
      </Paragraph>

      <BonoboLink
        bg="#fff"
        color="#000"
        css={{ whiteSpace: 'pre' }}
        width={['100%', 'auto']}
        to="mailto:flow@bonobolabs.com?subject=Sharing work on Flow Gallery"
        external
        appendArrow
      >
        Contact us
      </BonoboLink>
    </Flex>
  )
}

const Flex = styled(BaseFlex)({}, border)
